<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid edit-supplier">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Suppliers</h4>
            <editSupplierForm></editSupplierForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
    
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import EditSupplierForm from "./EditSupplierForm.vue";
export default {
    name: "EditSupplier",
    components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    editSupplierForm : EditSupplierForm
  },
  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "addSupplier",
        activeMenu: this.activeMenu ? this.activeMenu : "productandsuppliers",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
}
</script>
<style lang="scss" scoped>
.edit-supplier {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>